import { defaultContactFieldsSlugs } from 'src/editor/shared/constants/contact-fields-slugs'
import { contactFieldLocoKeys } from 'src/shared/constants/contact-field-loco-keys'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import { contactFieldsQuery } from '../api/queries/contact-fields-query'

export const useGetContactFieldName = () => {
  const { t } = useTypedTranslation()

  const { data: contactFields } = contactFieldsQuery.useQuery()

  return (slug: ContactSlugEnum) => {
    const isCustomField = !defaultContactFieldsSlugs.includes(slug)
    if (isCustomField) {
      const field = contactFields?.find(field => field.slug === slug)
      if (field) {
        // NOTE: We don't have translation for custom fields, so we return the fieldName
        return field.fieldName
      } else {
        return ''
      }
    } else {
      return t(contactFieldLocoKeys[slug])
    }
  }
}
